import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { Bell, Clock, Globe, Mail, Monitor, Shield } from 'lucide-react'
import { FREE_PLAN, formatCheckIntervalLabel } from '../../content/planMarketing'
import { LandingHeroVisual } from './LandingHeroVisual'
import { landingLinkClass } from './landingLinkStyles'

const features = [
  { icon: Monitor, text: `${FREE_PLAN.monitors} monitors on the free plan` },
  { icon: Shield, text: 'Escalation policies you control' },
  { icon: Bell, text: 'Slack alerts when sites go down' },
  { icon: Mail, text: 'Email alerts on every plan' },
  { icon: Globe, text: 'Public status page included free' },
  { icon: Clock, text: `${formatCheckIntervalLabel(FREE_PLAN.intervalMinutes)} on the Free Plan` },
]

export function LandingHero() {
  return (
    <section className="relative z-10 px-4 pb-16 pt-4 text-text-primary sm:px-8 sm:pb-24 sm:pt-8">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="mb-4 inline-flex rounded-full border border-border bg-surface/60 px-3 py-1 text-xs font-medium text-accent backdrop-blur-sm">
            {FREE_PLAN.monitors} Monitors included - Free
          </p>

          <h1 className="hero-h1 text-3xl font-bold leading-tight tracking-tight text-text-primary sm:text-4xl lg:text-5xl">
            Know when your sites go down—before your users do
          </h1>

          <p className="mt-4 max-w-xl text-base leading-relaxed text-text-secondary sm:text-lg">
            Pingscalate monitors your URLs, SSL certificates, and domain registrations on a
            schedule, shows a clear status view, and sends Slack or email alerts when something
            fails.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/signup"
              className={clsx(landingLinkClass('primary', 'md'), 'px-5')}
            >
              Start Free
            </Link>
          </div>

          <ul className="mt-10 space-y-3">
            {features.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-center gap-3 text-sm text-text-secondary">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent/15">
                  <Icon className="h-4 w-4 text-accent" aria-hidden />
                </span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        <LandingHeroVisual />
      </div>
    </section>
  )
}
